module.exports = "/_next/static/images/7c7be31929528ebf2ed9b302c5b6330d-nobureaucracy@3x.png.webp";